













































































































import Vue from 'vue';
import { ICheckoutLinks } from '@/common/interfaces/checkout.interface';
import TIcons from '@/types/TIcons';
import { IIcons } from '@/common/interfaces/index.interface';

interface ICheckoutCheckboxesComponent {
  icons: IIcons;
  links: ICheckoutLinks;
  locizeNamespace: string;
  partnerShipmentAuthorized: boolean;
  termsAndConditionsChecked: boolean;
  termsCountrySpecificChecked: boolean;
  termsRetourChecked: boolean;
}

export default Vue.extend({
  data(): ICheckoutCheckboxesComponent {
    return {
      icons: TIcons,
      links: window.vueCheckoutLinks,
      locizeNamespace: `checkout:`,
      partnerShipmentAuthorized: this.partnerShipmentAuthorizedPrechecked,
      termsAndConditionsChecked: this.termsAndConditionsPrechecked,
      termsCountrySpecificChecked: this.termsCountrySpecificPrechecked,
      termsRetourChecked: this.termsRetourPrechecked,
    };
  },
  props: {
    deliveryCountryIsoForSpecificTerms: {
      default: undefined,
      type: String,
    },
    partnerShipmentAuthorizedPrechecked: {
      default: false,
      type: Boolean,
    },
    showPartnerAddressCheckbox: {
      default: false,
      type: Boolean,
    },
    termsAndConditionsPrechecked: {
      default: false,
      type: Boolean,
    },
    termsCountrySpecificPrechecked: {
      default: false,
      type: Boolean,
    },
    termsRetourPrechecked: {
      default: false,
      type: Boolean,
    },
    triedToSubmit: {
      default: false,
      type: Boolean,
    },
  },
  watch: {
    partnerShipmentAuthorized: {
      handler(): void {
        this.$emit(`input:partner-shipment-authorized`, this.partnerShipmentAuthorized);
      },
    },
    termsAndConditionsChecked: {
      handler(): void {
        this.$emit(`input:terms-and-conditions`, this.termsAndConditionsChecked);
      },
    },
    termsCountrySpecificChecked: {
      handler(): void {
        this.$emit(`input:terms-country-specific`, this.termsCountrySpecificChecked);
      },
    },
    termsRetourChecked: {
      handler(): void {
        this.$emit(`input:terms-retour`, this.termsRetourChecked);
      },
    },
  },
});
